export enum License {
  IVR = 'IVR',
  Conference = 'Conference',
  CallCenter = 'CallCenter',
}
